import {useState} from "react"
import {fetchData} from "../util/Server"
import Endpoints from "../util/Endpoints"
import {ERROR, Notify} from "../util/Notify"

const useAuditLogs = ({action, targetType, targetId, actorId, page = 1, limit = 25} = {}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [rows, setRows] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const loadAuditLogs = () => {
        setIsLoading(true)

        const params = new URLSearchParams()
        if (action) params.append("action", action)
        if (targetType) params.append("target_type", targetType)
        if (targetId) params.append("target_id", targetId)
        if (actorId) params.append("actor_id", actorId)
        params.append("page", page)
        params.append("limit", limit)
        const qs = params.toString()
        const endpoint = qs ? `${Endpoints.ADMIN_AUDIT_LOGS}?${qs}` : Endpoints.ADMIN_AUDIT_LOGS

        fetchData(endpoint)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false)
                if (res?.code === 200) {
                    setRows(res.data?.rows || [])
                    setTotalRows(res.data?.total_rows || 0)
                    setTotalPages(res.data?.total_pages || 0)
                } else {
                    Notify(res?.message || "Failed to load audit logs", ERROR)
                }
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    return {
        isLoading,
        rows,
        totalRows,
        totalPages,
        loadAuditLogs,
    }
}

export default useAuditLogs
